import React from 'react';
import { IMaskMixin } from 'react-imask';
import FormInput from './FormInput';

const FormMaskedInput = IMaskMixin(({ inputRef, ...props }) => (
    <FormInput {...props} innerRef={inputRef} />
));

export default FormMaskedInput;
